<template>
  <div class="theme-switcher">
    <span>Display Mode</span>
    <div class="radio-buttons">
      <label>
        <input
          type="radio"
          name="theme"
          value="light"
          @change="setTheme('light')"
          :checked="currentTheme === 'light'"
        />
        Light
      </label>
      <label>
        <input
          type="radio"
          name="theme"
          value="dark"
          @change="setTheme('dark')"
          :checked="currentTheme === 'dark'"
        />
        Dark
      </label>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useThemeStore } from '@/stores'
import { storeToRefs } from 'pinia'

const themeStore = useThemeStore()
const { currentTheme } = storeToRefs(themeStore)

const setTheme = (theme: string) => {
  themeStore.setTheme(theme)
}
</script>

<style scoped>
.theme-switcher {
  display: flex;
  gap: 0.3125rem;
  font-size: var(--font-size-small);
  font-style: italic;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  align-items: center;
}

.theme-switcher .radio-buttons {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 1.25rem;
  width: 50%;
}

.theme-switcher .radio-buttons label {
  cursor: pointer;
  color: var(--text-color);
  display: flex;
  align-items: center;
  gap: 0.15625rem;
  width: 3.125rem;
}
</style>
